import { getApiMessage } from "@/utils/apiResponse.js";

const ADMIN_UNAUTHORIZED_MESSAGE =
  "You are not authorized to access the admin portal";

function isAdminUnauthorizedError(error) {
  const message = String(error?.message || error || "").toLowerCase();
  return (
    message.includes("not_authorized") ||
    message.includes("not authorized") ||
    message.includes("defineauthchallenge") ||
    message.includes("kindly signup") ||
    message.includes("kindly sigup")
  );
}

export function getAuthErrorMessage(error, fallback = "Something went wrong") {
  if (isAdminUnauthorizedError(error)) {
    return ADMIN_UNAUTHORIZED_MESSAGE;
  }
  return getApiMessage(error, fallback);
}
